import { call, put, takeEvery } from 'redux-saga/effects';
import { ChangeDataAccelerationTaskSchedule, DeleteDataAccelerationTask, RunDataAccelerationTaskRunNow } from '../../../actions/AppActionTypes';
import { DataAccelerationTaskMenuAction } from '../../../actions/spaces/dataAcceleration/DataAccelerationTaskMenuAction';
import { DeleteDataAccelerationTasksAction } from '../../../../ts/services/dataAcceleration/DeleteDataAccelerationTasksAction';
import { IAccelerationTaskInfo } from '../../../../ts/models/IAccelerationTaskInfo';
import { Messages } from '../../../../codegen/Localize';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { RunDataAccelerationTasksAction } from '../../../../ts/services/dataAcceleration/RunDataAccelerationTasksAction';
import { SagaIterator } from 'redux-saga';
import { ServiceLocator } from '../../../ServiceLocator';
import { Set } from '../../../../ts/models/Set';
import { ChangeScheduleActionService } from '../../../../ts/services/ChangeScheduleAction';

export function* handleRunNow(action: DataAccelerationTaskMenuAction) {
  try {
    yield call(runNow, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function runNow(accelerationTasks: IAccelerationTaskInfo[]) {
  return RunDataAccelerationTasksAction.showRunDataAccelerationDialog(Set.fromIdItemArray(accelerationTasks));
}

export function* handleDeleteDataAccelerationTask(action: DataAccelerationTaskMenuAction) {
  try {
    yield call(executeDeleteDataAccelerationTask, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function executeDeleteDataAccelerationTask(items: IAccelerationTaskInfo[]) {
  return DeleteDataAccelerationTasksAction.executeWithContext(Set.fromIdItemArray(items));
}

export function* handleChangeDataAccelerationTaskSchedule(action: DataAccelerationTaskMenuAction) {
  try {
    yield call(executeChangeDataAccelerationTaskSchedule, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function executeChangeDataAccelerationTaskSchedule(items: IAccelerationTaskInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ChangeScheduleActionService.forDataAccelerationTasks(Set.fromIdItemArray(items), context);
}

export function* rootAccelerationTaskMenuActionSaga(): SagaIterator {
  yield takeEvery(RunDataAccelerationTaskRunNow, handleRunNow);
  yield takeEvery(DeleteDataAccelerationTask, handleDeleteDataAccelerationTask);
  yield takeEvery(ChangeDataAccelerationTaskSchedule, handleChangeDataAccelerationTaskSchedule);
}
